var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { get } from "lodash";
import { COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS } from "@irati/deals/constants/dealType";
import TicketRepeater from "./TicketRepeater";
import SuccessImage from "./SuccessImage";
import Terms from "./Terms";
import BirthdayBoxTicket from "./Ticket/BirthdayBoxTicket";
import TicketTop from "./TicketTop";
import TicketBottom from "./TicketBottom";
import TicketInstructions from "./TicketInstructions";
import DownloadPdf from "./DownloadPdf";
import ContactInfo from "../DealInfoBlock/ContactInfo";
import "./styles/Tickets.css";
var Tickets = /** @class */ (function (_super) {
    __extends(Tickets, _super);
    function Tickets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showBirthdayBoxTicket = function () {
            var _a;
            return !!((_a = _this.props.deal) === null || _a === void 0 ? void 0 : _a.isBirthdayBox);
        };
        return _this;
    }
    Tickets.prototype.render = function () {
        var pdf = get(this.props.redemption, "pdf");
        var _a = this.props, deal = _a.deal, redemption = _a.redemption, vouchers = _a.vouchers, children = _a.children;
        return (React.createElement("div", { className: "tickets" },
            React.createElement(TicketTop, null,
                React.createElement(SuccessImage, { vouchers: this.props.vouchers }),
                React.createElement(TicketInstructions, { item: deal, instructions: get(redemption, "deal.redemptionInstructions") }),
                React.createElement(DownloadPdf, { pdf: pdf, className: "center" })),
            this.showBirthdayBoxTicket() && (React.createElement(BirthdayBoxTicket, { vouchers: vouchers })),
            !this.showBirthdayBoxTicket() && (React.createElement(TicketRepeater, { redemptionId: redemption.uuid, vouchers: vouchers })),
            React.createElement(TicketBottom, null,
                children,
                React.createElement(Terms, null),
                get(deal, "type") === DEAL_TYPE_COMPANY_BENEFITS &&
                    React.createElement(ContactInfo, { showHr: false, deal: deal }))));
    };
    Tickets.defaultProps = {
        children: null
    };
    return Tickets;
}(Component));
export default Tickets;
